import React, { useEffect, useState } from 'react'
import { useBuyapowaReferred } from 'app/hooks'
import { Buyapowa } from './Buyapowa'
import { CookiesNotification } from './CookiesNotification'
import { useConfig } from '@ynap/immutables-provider'

export const Referred = ({
    country,
    messages,
    language,
    rootElem,
    errorElem,
    buyapowaURL,
    buyapowaCampaign,
    buyapowaMarket,
    query = {},
}) => {
    const [showCookiesNotification, setShowCookiesNotification] = useState(false)
    const config = useConfig()

    useEffect(() => {
        if (typeof window.cact === 'function') {
            window.cact('consent.get', ({ consent }) => {
                const privacyId = config.head?.buyapowaPrivacyId
                if (!privacyId) return
                const buyapowaCategory = consent.categories[privacyId] || {}
                return buyapowaCategory.status === 'on'
                    ? setShowCookiesNotification(false)
                    : setShowCookiesNotification(true)
            })
        }
    }, [])

    const loading = useBuyapowaReferred({
        country,
        language,
        rootElem,
        errorElem,
        buyapowaURL,
        buyapowaCampaign,
        buyapowaMarket,
    })

    // only show the page if the url has query that starts with 'bp_'
    // without 'bp_' query it will only show the refer friend form
    const showReferred = Object.keys(query).find((k) => k.indexOf('bp_') === 0)

    return showCookiesNotification ? (
        <CookiesNotification title={messages.referrals.landingTitle()} message={messages.referrals.cookieMessage()} />
    ) : showReferred ? (
        <Buyapowa
            title={messages.referrals.landingTitle()}
            rootElem={rootElem}
            errorElem={errorElem}
            loading={loading}
            messages={messages}
        />
    ) : null
}
